import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { KzAccordionComponent } from "./kz-accordion.component";
import { KzAccordionItem } from "./directives/kz-accordion-item.directive";
import { KzAccordionContent } from "./directives/kz-accordion-content.directive";
import { KzAccordionTitle } from "./directives/kz-accordion-title.directive";
import { KzAccordionHeader } from "./directives/kz-accordion-header.directive";
import { TogglePipe } from './toggle.pipe';

@NgModule({
  declarations: [
    KzAccordionComponent,
    KzAccordionItem,
    KzAccordionContent,
    KzAccordionTitle,
    KzAccordionHeader,
    TogglePipe
  ],
  imports: [CommonModule],
  exports: [
    KzAccordionComponent,
    KzAccordionItem,
    KzAccordionContent,
    KzAccordionTitle,
    KzAccordionHeader
  ]
})
export class KzAccordionModule { }
